import { useState, useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import AdminSidebar from '../components/adminSideBar/adminSideBar'
import localStorage from 'local-storage'
import { Box, Container, Fade, useTheme, alpha } from '@mui/material'
import { motion } from 'framer-motion'

// Sidebar genişlikleri adminSideBar.js ile birebir aynı olmalı.
const SIDEBAR_WIDTH = { open: 260, closed: 72 }

const AdminLayout = () => {
  const [isOpen, setIsOpen] = useState(true)
  const [mounted, setMounted] = useState(false)
  const theme = useTheme()

  useEffect(() => {
    // Not: eskiden 'admin_sidebar' okunuyordu ama 'sidebar' yazılıyordu; tercih
    // hiç kalıcı olmuyor, üstelik kullanıcı tarafının ayarını da eziyordu.
    if (localStorage.get('admin_sidebar') === 'false') {
      setIsOpen(false)
    }
    setTimeout(() => setMounted(true), 100)
  }, [])

  const toggleSidebar = () => {
    setIsOpen((prev) => {
      localStorage.set('admin_sidebar', `${!prev}`)
      return !prev
    })
  }

  const currentSidebarWidth = isOpen ? SIDEBAR_WIDTH.open : SIDEBAR_WIDTH.closed

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        width: '100%',
        minHeight: '100vh',
        background: `linear-gradient(135deg, ${theme.palette.background.default} 0%, ${alpha(
          theme.palette.background.paper,
          0.8
        )} 100%)`,
        overflow: 'hidden',
      }}
    >
      {/* Arka plan ışık efekti */}
      <Box
        component={motion.div}
        animate={{ opacity: [0.3, 0.5, 0.3], scale: [1, 1.1, 1] }}
        transition={{ duration: 8, repeat: Infinity, ease: 'easeInOut' }}
        sx={{
          position: 'fixed',
          top: '-10%',
          left: '-5%',
          width: '40%',
          height: '40%',
          background: `radial-gradient(circle, ${alpha(
            theme.palette.primary.main,
            0.08
          )} 0%, transparent 70%)`,
          pointerEvents: 'none',
          filter: 'blur(60px)',
          zIndex: 0,
        }}
      />

      {/* Grid deseni */}
      <Box
        sx={{
          position: 'fixed',
          inset: 0,
          backgroundImage: `
            linear-gradient(${alpha(theme.palette.primary.main, 0.03)} 1px, transparent 1px),
            linear-gradient(90deg, ${alpha(theme.palette.primary.main, 0.03)} 1px, transparent 1px)
          `,
          backgroundSize: '50px 50px',
          pointerEvents: 'none',
          zIndex: 0,
          opacity: 0.5,
        }}
      />

      {/* Sidebar */}
      <Box
        sx={{
          width: currentSidebarWidth,
          position: 'fixed',
          top: 0,
          left: 0,
          height: '100vh',
          zIndex: 1200,
          transition: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        }}
      >
        <AdminSidebar status={isOpen} toggleSidebar={toggleSidebar} />
      </Box>

      {/* İçerik */}
      <Box
        component={motion.div}
        initial={{ opacity: 0, x: 20 }}
        animate={{ opacity: mounted ? 1 : 0, x: mounted ? 0 : 20 }}
        transition={{ duration: 0.5, ease: 'easeOut' }}
        sx={{
          marginLeft: `${currentSidebarWidth}px`,
          width: `calc(100% - ${currentSidebarWidth}px)`,
          display: 'flex',
          flexDirection: 'column',
          transition:
            'margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1), width 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          position: 'relative',
          zIndex: 1,
          minHeight: '100vh',
        }}
      >
        <Container
          maxWidth="xl"
          sx={{ flex: 1, py: 4, px: { xs: 2, sm: 3, md: 4 } }}
        >
          <Fade in={mounted} timeout={800}>
            <Box
              component={motion.div}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              sx={{
                minHeight: 'calc(100vh - 120px)',
                position: 'relative',
                overflow: 'hidden',
              }}
            >
              <Box sx={{ position: 'relative', zIndex: 1 }}>
                <Outlet />
              </Box>
            </Box>
          </Fade>
        </Container>
      </Box>
    </Box>
  )
}

export default AdminLayout
